import * as React from 'react';
import * as Moment from 'moment';
import { GetLayoutStyle } from '../../zusatztools/pdf/layout';
import { getStyle } from './DatanauswertungGenerischStyles';

export function renderDocxRows(config: any): React.ReactElement {
    const { custom_layout, custom_row_classes, row_classes, rows, docxRows } = config;
    const tableRows = docxRows && Array.isArray(docxRows) && docxRows.length > 0 ? docxRows : rows;
    if (tableRows && tableRows.length > 0) {
        return <table style={{ border: 'none', borderCollapse: 'collapse' }}>
            {tableRows.map((row: any, i: number) => {
                return <tr key={`tr-${i}`}>
                    {Array.isArray(row) && row.map((vals: any, j: number) => {
                        const className = custom_row_classes && custom_row_classes[i] && custom_row_classes[i][j] ? custom_row_classes[i][j] : row_classes && row_classes[j] ? row_classes[j] : 'row_field';
                        const tdStyle: any = getStyle(className, false, 1, custom_layout, { colIndex: j, className });
                        const colSpan: number = tdStyle.colSpan || 1;
                        return <td key={`td-${i}-${j}`} colSpan={colSpan} style={{
                            // width und height spielen in der Klasse keine Rolle, sie werden automatisch berechnet.
                            // padding und margin spielen in der Klasse keine Rolle.
                            textAlign: tdStyle.textAlign,
                            borderLeft: tdStyle.borderLeft,
                            borderTop: tdStyle.borderTop,
                            fontSize: tdStyle.fontSize,
                            fontWeight: tdStyle.fontWeight,
                            color: tdStyle.color,
                            backgroundColor: tdStyle.backgroundColor,
                        }}>
                            {Array.isArray(vals) ?
                                <p>
                                    {vals.map((val: any, k: number) => <>
                                        {k > 0 && val && <br />}
                                        <span key={`tdc-${i}-${j}-${k}`}>{val}</span>
                                    </>)}
                                </p>
                                : vals}
                        </td>;
                    })}
                </tr>;
            })}
        </table>;
    }
    return <div></div>;
}

export function renderDocxHeader(config: any, logoImgB64: string): React.ReactElement {
    const { titel0, titel1, titel2 } = config;
    const style: any = new GetLayoutStyle().styles();
    const titleFont: any = style.titleFont || {};
    const titleFont2: any = style.titleFont2 || {};
    const titleFont3: any = style.titleFont3 || {};
    const titleFont4: any = style.titleFont4 || {};
    // flex, padding und margin spielen in der Klasse keine Rolle. Die Ausrichtung der Elemente ist kaum möglich.
    return <table style={{ border: 'none', borderCollapse: 'collapse' }}>
        <tr>
            <td>
                <div style={{ fontWeight: 'bold' }}><span style={{ ...titleFont }}></span> {titel0 && <span style={{ ...titleFont2 }}>{titel0}</span>}</div>
                <div style={{ fontWeight: 'bold' }}>→&nbsp;{titel1 && <span style={{ ...titleFont3 }}>{titel1}: </span>} {titel2 && <span style={{ ...titleFont4 }}>{titel2}</span>}</div>
            </td>
            <td>
                <img src={logoImgB64} alt='logo' style={{ ...style.titleImage2 }} />
            </td>
        </tr>
    </table>;
}

export function renderDocxFooter(): React.ReactElement {
    // Leider muss es so sein: width spielt in der Klasse keine Rolle; Die Seitennummer kann man nicht elegant positionieren; die Zeile muss voll ausgefüllt werden.
    // Anzeige der Seitennummer ist nicht anpassbar. "Seite X von Y" unmöglich.
    return <p>
        {Moment().format('DD.MM.YYYY')}
        &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
        &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
        &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
        &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
        Seite&nbsp;
    </p>;
}

export function renderDocxDiagram(config: any, pngB64s: Array<string>): React.ReactElement {
    const { diagrams } = config;
    if (Array.isArray(diagrams) && diagrams.length > 0) {
        const styleTitle = getStyle('diagrammTitle');
        return <div style={{}}>
            {pngB64s.map((b64: string, i: number) => {
                return <div key={`diagram-${i}`}>
                    <h4 style={{ color: styleTitle.color, backgroundColor: styleTitle.backgroundColor, textAlign: 'center' }}>{diagrams[i] && diagrams[i].titlePdf}</h4>
                    <p style={{ textAlign: 'center' }}>
                        {diagrams[i] && Array.isArray(diagrams[i].legend) && diagrams[i].legend.map((name: any, j: number) => {
                            let backgroundColor = 'white';
                            if (diagrams[i] && diagrams[i].legendIconColor && diagrams[i].legendIconColor[i]) {
                                backgroundColor = diagrams[i].legendIconColor[j];
                            } else if (diagrams[i] && diagrams[i].lineColor && diagrams[i].lineColor[j]) {
                                backgroundColor = diagrams[i].lineColor[j];
                            }
                            return <span key={`legend-${i}`}>
                                <span style={{ backgroundColor }} >&nbsp;&nbsp;&nbsp;</span>&nbsp;<span>{name}</span>&nbsp;&nbsp;&nbsp;
                            </span>;
                        })}
                    </p>
                    <img src={b64} alt='logo' style={{}} />
                </div>;
            })}
        </div>;
    }
    return null;
}
